/**
 * Shared lighting constants for the workspace 3D scene.
 *
 * Per-scene lighting components (e.g. `Lighting`, `ModelPreviewLighting`,
 * `IesScene`) intentionally remain separate — each scene has different needs.
 * Only the values that should stay in sync across the workspace live here.
 */

/** Key-light direction used by the workspace ambient/directional/hemisphere rig. */
export const KEY_LIGHT_POSITION: [number, number, number] = [300, 700, 1000];

/** Ground color for the workspace hemisphere light. */
export const HEMISPHERE_GROUND_COLOR = 0x222222;

/**
 * Shadow camera frustum for the workspace key directional light.
 *
 * Sized generously so that shadows render for any plausible scene without
 * having to refit the frustum to the model bounds every frame. If users
 * routinely load scenes that escape these bounds, switch to dynamic frustum
 * fitting (compute scene bbox, recenter `light.target`, resize the frustum)
 * rather than enlarging these values further — bigger frustum = lower
 * effective shadow resolution per world unit.
 */
export const KEY_LIGHT_SHADOW_CAMERA = {
  near: 0.1,
  far: 5000,
  left: -500,
  right: 500,
  top: 500,
  bottom: -500,
} as const;
